export default "__VITE_ASSET__M6BDQQrc__"